/* eslint-disable */
import $ from 'jquery';
import inputmask from "inputmask";
import Swiper from 'swiper';
import ymaps from 'ymaps';
import { Fancybox } from "@fancyapps/ui";

window.$ = $;
window.jQuery = $;

Fancybox.bind("[data-fancybox]", {});

// start slider
$(() => {
    const swiper = new Swiper(".start .swiper", {
        navigation: {
          nextEl: ".start .swiper .swiper-button-next",
          prevEl: ".start .swiper .swiper-button-prev",
        },
        autoplay: {
            delay: 3500
        }
    });
});

// products slider
$(() => {
    const swiper = new Swiper(".slider-products .swiper", {
        navigation: {
          nextEl: ".sales .swiper .swiper-button-next",
          prevEl: ".sales .swiper .swiper-button-prev",
        },
        slidesPerView: 3,
        spaceBetween: 30,
        autoplay: {
            delay: 3500
        },
        breakpoints: {
            320: {
                slidesPerView: 1
            },
            991: {
                slidesPerView: 3
            }
        }
    });
});

// slider gallery product
$(() => {
    const thumbs = new Swiper(".gallery__thumbs", {
        spaceBetween: 0,
        slidesPerView: 5,
        navigation: {
            nextEl: ".gallery__thumbs .swiper-button-next",
            prevEl: ".gallery__thumbs .swiper-button-prev",
        },
      });
    const main = new Swiper(".gallery__main", {
        spaceBetween: 0,
        thumbs: {
            swiper: thumbs
        }
    });
});

// hover colors
$(() => {
    $('.product__parameters.parameters .parameters__color label').hover(
        function() {
            $(this).find('span').fadeIn();
        },
        function() {
            $(this).find('span').fadeOut();
        }
    );
});

// tabs product
$(() => {
    const tab = $('.product__nav button.active').data('tab');
    $(tab).show();

    $('.product__nav button').on('click', function() {
        const tab = $(this).data('tab');

        $('.product__nav button').removeClass('active');
        $('.tab').hide();

        $(this).addClass('active');
        $(tab).show();
    });
});

// map
$(() => {
    const map = $('#map');
    if (map.length) {
        const coords = map.data('coords').split(',');

        ymaps.load('https://api-maps.yandex.ru/2.1/?lang=ru_RU').then((maps) => {
            const myMap = new maps.Map('map', {
                center: coords,
                zoom: 16,
                controls: []
            }, {
                searchControlProvider: 'yandex#search',
            });

            const myPlacemark = new maps.Placemark(coords, {}, {});
  
            myMap.geoObjects.add(myPlacemark);

            myMap.behaviors.disable('scrollZoom');
            map.addClass('noZoom');
            myMap.events.add('click', () => {
                if (map.hasClass('noZoom')) {
                    map.removeClass('noZoom').addClass('yesZoom');
                    myMap.behaviors.enable('scrollZoom');
                } else {
                    map.removeClass('yesZoom').addClass('noZoom');
                    myMap.behaviors.disable('scrollZoom');
                }
            });
  
            const isMobile = {
                Android: () => (navigator.userAgent.match(/Android/i)),
                BlackBerry: () => (navigator.userAgent.match(/BlackBerry/i)),
                iOS: () => (navigator.userAgent.match(/iPhone|iPad|iPod/i)),
                Opera: () => (navigator.userAgent.match(/Opera Mini/i)),
                Windows: () => (navigator.userAgent.match(/IEMobile/i)),
                any: () => (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows())
            };
  
            if (isMobile.any()) {
                myMap.behaviors.disable('drag');
            }
        }).catch(error => console.log('Failed to load Yandex Maps', error));
    }
});

// switch cart
$(() => {
    $('.cart__order button').on('click', () => {
        $('#cart').hide();
        $('#order').show();
    });
});

// mob header
$(() => {
    // switch header
    $('.header__burger').on('click', () => {
        $('.header-mobile').addClass('active');
    });
    $('.header-mobile__close').on('click', () => {
        if ($('.header-mobile__search').hasClass('active')) {
            $('.header-mobile__search').removeClass('active');
        } else {
            $('.header-mobile').removeClass('active');
        }
    });
    // switch menu
    $('.header-mobile__menu-site > li').on('click', function() {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $(this).addClass('active');
        }
    });
    // switch search
    $('.header-mobile__search-btn').on('click', () => {
        if ($('.header-mobile__search').hasClass('active')) {
            $('.header-mobile__search').removeClass('active');
        } else {
            $('.header-mobile__search').addClass('active');
        }
    });
});

// size product
$(() => {
    const initSize = $('#size').val();
    const initSleep = $(`#size option[value="${initSize}"]`).data('sleep');
    
    $('#sleep b').text(initSleep);

    $('#size').on('change', function() {
        const size = $(this).val();
        const sleep = $(this).find(`option[value="${size}"]`).data('sleep');

        $('#sleep b').text(sleep);
        
        if (sleep === '') {
            $('#sleep b').hide();
        } else {
            $('#sleep b').show();
        }
    });
});

// count product
$(() => {
    $('.product__count button, .product-catalog__count button').on('click', function() {
        const type = $(this).text();
        const $input = $(this).parent().find('input[name=count]');
        let count = +$input.val();

        switch (type) {
            case '+':
                count += 1;
                $input.val(count);
                break;
            case '-':
                count -= 1;
                if (count > 0) $input.val(count);
                break;
            default:
                break;
        }
    });
});

// mechanism input
$(() => {
    const $input = $('#mechanism');

    if ($input.length) {
        $('#mechanism').on('change', function() {
            $input.val($(this).prop('checked') ? 1 : 0);
        });
    }
});

// cart
$(() => {
    // console.log(miniShop2.Cart.getcost());
});

// send review
$(() => {
    const $form = $('#writeReview form');

    function num_word(value, words){  
        value = Math.abs(value) % 100; 
        var num = value % 10;
        if(value > 10 && value < 20) return words[2]; 
        if(num > 1 && num < 5) return words[1];
        if(num == 1) return words[0]; 
        return words[2];
    }

    $form.find('[name=images]').on('change', function() {
        const files = $(this)[0].files;
        $form.find('.file span').text(`${files.length} ${num_word(files.length, ['файл', 'файла', 'файлов'])}`);
    });

    $form.on('submit', function(e) {
        e.preventDefault();
        const formData = new FormData();
        const files = $form.find('[name=images]')[0].files;

        for (let i = 0; i < files.length; i++) {
            formData.append(`images[]`, files[i]);
        }


        formData.append('name', $form.find('[name=name]').val());
        formData.append('mail', $form.find('[name=mail]').val());
        formData.append('text', $form.find('[name=text]').val());

        $form.find('.form__submit button').text('Загрузка...').prop('disabled', true);

        $.ajax({
            url : 'api/send/review',
            type : 'POST',
            data : formData,
            processData: false,  // tell jQuery not to process the data
            contentType: false,  // tell jQuery not to set contentType
            dataType: 'json',
            success : function(response) {
                if (response.success) {
                    alert('Спасибо за отзыв! Мы опубликуем его после модерации.');
                } else {
                    alert('Произошла ошибка при отправке. Повторите позже.');
                }
                
                $('#writeReview').modal('hide');
            },
            error: function() {
                alert('Произошла ошибка при отправке. Повторите позже.');
            }
        });

        return false;
    });
});

// menu-catalog
$(() => {
    $('.menu-catalog li').hover(
        function() {
            // $('.menu-catalog > li').removeClass('active');
            $(this).addClass('active');
        },
        function() {
            const $then = $(this);
            setTimeout(() => {
                $then.removeClass('active');
            }, 500);
        }
    );
});

// colors fallery
$(() => {
    $('.parameters__color label').on('click', function() {
        
    });
});